import React from 'react';

// V1 根站点提示页: 默认访问 https://words.acesimba.cloud/ 时显示,
// 告知用户已切换到分组模式并引导到 /split/。开发者模式(?dev=1 或 localStorage.v1_dev=1)下不显示。
// 风格: 卡通风趣 + 优雅(柔和渐变背景, 圆角卡片, 柔和阴影, 渐变文字与胶囊按钮)。
export default function V1Notice() {
  return (
    <div
      style={{
        minHeight: '100vh',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)',
        fontFamily: '"PingFang SC", "Microsoft YaHei", "Hiragino Sans GB", system-ui, -apple-system, sans-serif',
        color: '#37474f',
      }}
    >
      <div
        style={{
          maxWidth: '580px',
          width: '100%',
          background: '#ffffff',
          borderRadius: '28px',
          padding: '52px 44px',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(80, 110, 160, 0.18)',
          border: '1px solid rgba(255, 255, 255, 0.6)',
        }}
      >
        <div style={{ fontSize: '76px', lineHeight: 1, marginBottom: '10px' }}>📚✨</div>
        <p
          style={{
            fontSize: '18px',
            lineHeight: 2,
            margin: '0 0 14px',
            color: '#546e7a',
          }}
        >
          您已经开始使用分组模式，请进入链接{' '}
          <a
            href="https://words.acesimba.cloud/split/"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#6a5acd', fontWeight: 600, textDecoration: 'none', borderBottom: '2px dashed #6a5acd' }}
          >
            https://words.acesimba.cloud/split/
          </a>
          。
        </p>
        <p
          style={{
            fontSize: '14px',
            lineHeight: 2,
            margin: '0 0 30px',
            color: '#546e7a',
          }}
        >
          如需要打开，请在开发者模式中进行打开。
        </p>
        <a
          href="https://words.acesimba.cloud/split/"
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'inline-block',
            padding: '13px 30px',
            borderRadius: '999px',
            background: 'linear-gradient(90deg, #6a5acd, #8e7cf0)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '16px',
            textDecoration: 'none',
            boxShadow: '0 10px 24px rgba(106, 90, 205, 0.35)',
          }}
        >
          🚀 进入分组模式
        </a>
      </div>
    </div>
  );
}
